// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import colors from "@store/Themes/common/styleguide/config/colors";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, PropsWithChildren, useState } from "react";
import { css } from "styled-components";

const resolveColorToken = (color: string) => {
    if (!color) {
        return;
    }
    return color.split(".").reduce((acc: any, key: string) => acc?.[key], colors);
};
interface ColorCellProps {
    color: string;
}

const ColorCell: FC<ColorCellProps> = ({ color }) => {
    return (
        <StyledWrapper
            css={css`
                border: 1px solid ${getColor("common.border")};
                border-radius: ${pxToRem(12)};
            `}
        >
            <StyledWrapper
                css={css`
                    min-width: ${pxToRem(190)};
                    height: ${pxToRem(105)};
                    background-color: ${getColor(color)};
                    border-radius: ${pxToRem(12)} ${pxToRem(12)} 0 0;
                `}
            ></StyledWrapper>
            <StyledWrapper
                css={css`
                    display: block;
                    padding: ${pxToRem(16)};

                    ${TypographyStyle} {
                        display: block;
                    }
                `}
            >
                <Typography
                    css={css`
                        font-weight: ${x => x.theme.design.typography.weight.semibold};
                        text-transform: capitalize;
                    `}
                >
                    {color}
                </Typography>
                <Typography
                    css={css`
                        color: ${getColor("text.accent")};
                    `}
                >
                    {resolveColorToken(color)}
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const ColorRow: FC<PropsWithChildren> = ({ children }) => {
    return (
        <StyledWrapper
            css={css`
                display: flex;
                gap: ${pxToRem(20)};
                flex-wrap: wrap;
                margin-bottom: ${pxToRem(20)};
            `}
        >
            {children}
        </StyledWrapper>
    );
};

const StyleguideColors: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Colors" sectionId={sectionId}>
            <ColorRow>
                <ColorCell color="primary.main" />
                <ColorCell color="primary.light" />
                <ColorCell color="primary.dark" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="secondary.main" />
                <ColorCell color="secondary.light" />
                <ColorCell color="secondary.dark" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="tertiary.main" />
                <ColorCell color="tertiary.light" />
                <ColorCell color="tertiary.dark" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="text.main" />
                <ColorCell color="text.accent" />
                <ColorCell color="text.disabled" />
                <ColorCell color="text.link" />
                <ColorCell color="text.linkHover" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="common.border" />
                <ColorCell color="common.borderLight" />
                <ColorCell color="common.borderDark" />
                <ColorCell color="common.background" />
                <ColorCell color="common.disabled" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="success.main" />
                <ColorCell color="success.light" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="warning.main" />
                <ColorCell color="warning.light" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="danger.main" />
                <ColorCell color="danger.light" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="info.main" />
                <ColorCell color="info.light" />
            </ColorRow>
            <ColorRow>
                <ColorCell color="placeholder.main" />
                <ColorCell color="placeholder.disabled" />
            </ColorRow>
        </StyleguideSection>
    );
};

export default StyleguideColors;
